module.exports = __webpack_public_path__ + "img/cg.f1a699f3.svg";